export const chevronLeft = () => {
  return (
    <svg
      height={25}
      width={25}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M15 6L9 12L15 18"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{" "}
      </g>
    </svg>
  );
};
export const chevronRight = () => {
  return (
    <svg
      width={25}
      height={25}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M9 6L15 12L9 18"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{" "}
      </g>
    </svg>
  );
};
export const LunarNewYearLamp = () => {
  return (
    <svg
      fill="#000000"
      height="20px"
      width="20px"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 297 297"
      xmlSpace="preserve"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <path d="M78.305,129.499c0,31.403,16.718,58.524,40.755,70.948c-8.062-18.687-12.192-44.901-12.192-70.948 c0-26.048,4.131-52.262,12.192-70.948C95.022,70.974,78.305,98.095,78.305,129.499z"></path>{" "}
          <path d="M126.231,129.499c0,51.583,15.609,78.184,22.269,78.184c6.659,0,22.269-26.601,22.269-78.184S155.159,51.315,148.5,51.315 C141.841,51.315,126.231,77.916,126.231,129.499z"></path>{" "}
          <path d="M218.695,129.499c0-31.404-16.718-58.525-40.755-70.948c8.062,18.686,12.192,44.9,12.192,70.948 c0,26.047-4.131,52.262-12.192,70.948C201.977,188.023,218.695,160.902,218.695,129.499z"></path>{" "}
          <path d="M190.133,9.683c0-5.348-4.335-9.683-9.682-9.683h-63.902c-5.347,0-9.682,4.335-9.682,9.683v11.86h83.266V9.683z"></path>{" "}
          <path d="M106.867,249.315c0,5.347,4.335,9.683,9.682,9.683h7.077c-0.511,2.015-0.783,4.122-0.783,6.293v22.027 c0,5.347,4.335,9.682,9.682,9.682s9.683-4.335,9.683-9.682v-22.027c0-3.47,2.823-6.293,6.293-6.293c3.47,0,6.293,2.823,6.293,6.293 v22.027c0,5.347,4.336,9.682,9.683,9.682s9.682-4.335,9.682-9.682v-22.027c0-2.171-0.272-4.278-0.783-6.293h7.077 c5.347,0,9.682-4.336,9.682-9.683v-11.86h-83.266V249.315z"></path>{" "}
          <path d="M58.94,129.499c0-42.92,25.581-79.453,61.009-92.465h-15.55c-19.217,4.568-36.877,12.127-51.756,22.356 c-26.846,18.455-41.63,43.354-41.63,70.108c0,26.754,14.784,51.652,41.63,70.108c14.879,10.229,32.539,17.787,51.756,22.355h15.55 C84.521,208.952,58.94,172.419,58.94,129.499z"></path>{" "}
          <path d="M244.356,59.391c-14.879-10.229-32.539-17.788-51.756-22.356h-15.55c35.428,13.012,61.009,49.545,61.009,92.465 s-25.581,79.453-61.009,92.464h15.55c19.217-4.568,36.877-12.127,51.756-22.355c26.846-18.456,41.63-43.355,41.63-70.108 C285.986,102.744,271.202,77.846,244.356,59.391z"></path>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};
export const JackoLantern = () => {
  return (
    <svg
      height="20px"
      width="20px"
      version="1.1"
      id="_x32_"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      fill="#000000"
    >
      <path d="M366.313,58.34c-32.779-4.382-64.158,2.121-86.979,6.297V35.006c0-5.948-4.825-10.766-10.774-10.766h-25.13 c-5.94,0-10.765,4.817-10.765,10.766v29.631c-22.821-4.176-54.2-10.679-86.987-6.297C32.612,73.464,0,152.872,0,246.401 c0,115.273,76.197,203.035,180.989,231.503c23.722,6.439,48.916,9.856,75.01,9.856c26.095,0,51.289-3.417,75.003-9.856 C435.803,449.436,512,361.674,512,246.401C512,152.872,479.387,73.464,366.313,58.34z M366.479,146.703l49.216,68.477 l-104.08,10.868L366.479,146.703z M254.695,218.091l33.016,41.717c-3.915,0-66.982,0-66.982,0L254.695,218.091z M140.063,146.703 l54.856,79.346L90.846,215.18L140.063,146.703z M355.113,408.857v-22.488h-44.929v38.933c-30.667,8.329-54.302,9.572-54.302,9.572 s-22.251,0.719-51.62-5.664v-42.84h-44.937v28.144c-44.494-20.218-88.972-60.417-95.553-140.292c0,0,24.932,11.058,85.966,18.003 v42.524h57.427v-38.094c14.365,0.68,31.443,1.076,49.122,1.076c20.012,0,37.042-0.506,54.991-1.36v38.379h55.639v-43.236 c57.434-6.96,80.635-17.291,80.635-17.291C445.667,347.072,400.896,387.018,355.113,408.857z"></path>
    </svg>
  );
};
export const ChristmasTree = () => {
  return (
    <svg
      height="20px"
      width="20px"
      version="1.1"
      id="_x32_"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="#000000"
    >
      <polygon
        className="st0"
        points="223.716,97.913 255.538,79.092 287.347,97.913 279.279,61.839 307.017,37.398 270.212,33.926 255.538,0 240.864,33.926 204.058,37.398 231.784,61.839 "
      ></polygon>
      <path
        className="st0"
        d="M453.486,391.713c-41.7-17.428-79.76-46.689-101.59-66.59c15.242-2.08,37.136-7.281,54.558-17.522 c2.035-1.199,3.247-3.415,3.147-5.776c-0.094-2.36-1.487-4.471-3.61-5.494c-33.239-16.042-65.361-50.612-80.047-67.808 c10.403-0.993,25.633-4.203,42.824-13.432c2.204-1.18,3.516-3.54,3.36-6.039c-0.162-2.498-1.761-4.67-4.096-5.564 c-53.358-20.4-106.299-93.598-106.83-94.334c-1.199-1.674-3.135-2.666-5.195-2.666c-2.061,0-3.996,0.993-5.195,2.673 c-0.532,0.73-53.416,73.903-106.842,94.322c-2.336,0.9-3.934,3.072-4.097,5.57c-0.156,2.498,1.155,4.858,3.36,6.039 c17.197,9.229,32.427,12.439,42.837,13.432c-14.694,17.197-46.821,51.766-80.048,67.808c-2.123,1.024-3.516,3.134-3.61,5.494 c-0.1,2.361,1.112,4.577,3.147,5.776c17.416,10.241,39.309,15.443,54.552,17.522c-21.843,19.907-59.922,49.181-101.597,66.59 c-2.21,0.925-3.721,3.01-3.909,5.402c-0.187,2.392,0.98,4.683,3.022,5.945c38.634,23.797,125.77,42.444,198.38,42.444 c72.598,0,159.732-18.646,198.366-42.444c2.042-1.262,3.21-3.553,3.023-5.945C457.208,394.723,455.696,392.638,453.486,391.713z M159.111,414.599c-11.178,0-20.244-9.066-20.244-20.244c0-11.177,9.067-20.244,20.244-20.244c11.178,0,20.244,9.067,20.244,20.244 C179.355,405.532,170.289,414.599,159.111,414.599z M213.462,300.564c-12.944,0-23.441-10.497-23.441-23.442 c0-12.95,10.497-23.447,23.441-23.447c12.951,0,23.448,10.497,23.448,23.447C236.91,290.066,226.414,300.564,213.462,300.564z M249.693,399.681c-10.59,0-19.177-8.586-19.177-19.176c0-10.59,8.586-19.176,19.177-19.176c10.591,0,19.177,8.586,19.177,19.176 C268.87,391.095,260.284,399.681,249.693,399.681z M251.823,207.852c0-10.01,8.111-18.121,18.115-18.121 c10.01,0,18.121,8.111,18.121,18.121c0,10.004-8.111,18.115-18.121,18.115C259.934,225.967,251.823,217.856,251.823,207.852z M293.386,326.141c-11.184,0-20.245-9.061-20.245-20.245c0-11.184,9.061-20.244,20.245-20.244c11.184,0,20.244,9.061,20.244,20.244 C313.63,317.08,304.569,326.141,293.386,326.141z M341.343,409.26c-12.945,0-23.442-10.497-23.442-23.442 c0-12.958,10.497-23.448,23.442-23.448c12.95,0,23.447,10.49,23.447,23.448C364.79,398.763,354.293,409.26,341.343,409.26z"
      ></path>
      <path
        className="st0"
        d="M201.423,457.73l11.558,50.024c0.575,2.492,2.642,4.246,5.021,4.246h75.989c2.373,0,4.446-1.754,5.02-4.246 l11.553-50.024c-18.458,1.998-36.936,3.116-54.558,3.116C238.378,460.846,219.888,459.728,201.423,457.73z"
      ></path>
    </svg>
  );
};

export const Menorah = () => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M12 21V7M21 6V5M3 6V5M12 4V3M17 6V5M7 6V5M21 9C21 13.9706 16.9706 18 12 18C7.02944 18 3 13.9706 3 9M17 9C17 11.7614 14.7614 14 12 14C9.23858 14 7 11.7614 7 9M8 21H16"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{" "}
      </g>
    </svg>
  );
};

export const Turkey = () => {
  return (
    <svg
      height="20px"
      width="20px"
      version="1.1"
      id="_x32_"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      fill="#000000"
      stroke="#000000"
      strokeWidth="0.00512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#000000"
        strokeWidth="9.216"
      >
        {" "}
        <style type="text/css"> </style>{" "}
        <g>
          {" "}
          <path
            className="st0"
            d="M438.574,178.819c-0.006,0-0.006,0.006-0.012,0.006l-0.597,0.471L438.574,178.819z"
          ></path>{" "}
          <path
            className="st0"
            d="M457.318,227.367l-0.284,0.121c0.006,0,0.012,0,0.019-0.006c0,0,0.006-0.006,0.012-0.006L457.318,227.367z"
          ></path>{" "}
          <path
            className="st0"
            d="M509.682,275.264c-2.451-5.88-6.64-10.414-11.585-13.577c0.471-2.113,0.749-4.28,0.749-6.49 c0-3.815-0.736-7.715-2.3-11.446c-4.829-11.591-16.046-18.618-27.878-18.611c-3.87,0-7.83,0.754-11.615,2.342 c-11.627,4.836-18.636,16.064-18.63,27.89c0,1.208,0.212,2.427,0.356,3.64c-0.018,0.006-0.03,0.012-0.048,0.018 c-1.745,0.622-3.568,1.274-5.156,1.872c-1.443,0.537-2.542,0.966-3.58,1.424l-6.514,2.608l-0.537,0.024 c-4.649,0.091-11.826-2.36-20.514-6.031c-5.723-2.373-12.194-5.132-19.288-7.618l0.428-0.139 c-2.064-6.339-4.207-14.12-7.987-21.654c2.868-2.53,5.228-5.3,6.991-8.174c4.365-7.136,5.668-14.458,6.598-19.945 c0.447-2.741,0.808-5.066,1.189-6.532c0.187-0.724,0.362-1.219,0.459-1.424c0.766-0.755,2.348-2.167,4.202-3.755 c2.994-2.572,6.737-5.668,9.707-8.101c0.048-0.036,0.085-0.066,0.127-0.103c4.316,2.952,9.285,4.582,14.204,4.528 c7.039-0.012,13.8-2.711,19.499-7.184l0.019-0.012c7.292-5.742,11.126-14.326,11.113-22.922c0.006-6.296-2.052-12.701-6.254-18.02 c-3.761-4.763-8.759-7.86-14.096-9.532c-0.368-5.59-2.264-11.216-6.025-15.985c-5.741-7.286-14.313-11.126-22.91-11.114 c-6.297-0.005-12.708,2.059-18.032,6.273l0.549-0.434l-0.537,0.422c-7.286,5.741-11.131,14.319-11.12,22.916 c-0.006,3.803,0.845,7.618,2.366,11.24l-4.014,3.17c-1.232,0.893-4.081,2.191-6.424,3.025c-1.195,0.434-2.288,0.79-3.054,1.026 l-0.893,0.266l-0.224,0.066l-0.042,0.012l-0.544,0.152l-0.5,0.217c-3.272,1.425-7.118,2.131-11.784,2.464 c-6.979,0.525-15.611,0.108-25.463,1.291c-8.91,1.075-18.853,3.647-29.164,9.496c-18.763-6.562-39.641-8.965-59.276-8.977 c-3.691,0-7.341,0.079-10.927,0.242h0.006c-30.67,1.34-53.728,9.72-71.252,21.714c-26.321,17.996-39.883,43.386-51.184,63.018 c-5.617,9.834-10.736,18.244-15.922,23.628c-2.587,2.705-5.125,4.66-7.724,5.934c-2.611,1.268-5.3,1.944-8.666,1.956 c-4.944,0.012-11.546-1.63-20.224-6.115l0.006,0.006c-3.082-1.6-6.254-2.488-9.375-2.488c-3.172-0.018-6.136,0.978-8.352,2.379 c-3.359,2.131-5.198,4.842-6.354,6.9c-0.912,1.654-1.382,2.958-1.597,3.622L2.542,322.001c-0.67,1.485-2.494,5.832-2.542,11.856 c-0.003,3.019,0.519,6.508,2.116,10.01c1.582,3.501,4.271,6.9,8.017,9.604c23.945,17.38,48.774,31.79,78.796,41.738 c30.021,9.961,65.101,15.436,109.566,15.43c23.459,0,44.712,0.12,63.903,0.12c25.968,0,48.147-0.223,66.957-1.298 c14.109-0.803,26.321-2.089,36.885-4.178c15.781-3.145,28.174-8.077,36.958-16.831c4.359-4.358,7.63-9.635,9.689-15.557 c2.071-5.928,2.982-12.454,2.982-19.595c0-3.097-0.223-6.357-0.549-9.714c6.23-7.256,10.298-14.476,13.631-19.861 c1.865-3.042,3.537-5.481,5.034-7.075c1.521-1.618,2.68-2.373,4.069-2.838c3.417-1.111,13.48-4.376,19.982-6.49 c1.944,2.506,4.238,4.636,6.828,6.212c4.54,2.783,9.731,4.045,14.905,4.039c4.594,0,9.206-0.972,13.601-2.795l0.018-0.006 c11.602-4.848,18.624-16.076,18.611-27.92C512,282.985,511.252,279.037,509.682,275.264z M330.798,168.037 c5.47-0.242,10.921-0.181,16.463-0.574c5.24-0.38,10.637-1.225,15.974-3.386c0.483-0.133,2.536-0.713,5.258-1.708 c3.03-1.129,6.682-2.584,10.076-4.938l0.151-0.103l15.72-12.394l-4.775-6.068c-1.998-2.541-2.934-5.481-2.94-8.451 c0.012-4.069,1.768-8.036,5.21-10.758l0.03-0.024c2.523-1.992,5.462-2.934,8.445-2.94c4.075,0.012,8.053,1.781,10.764,5.222 c1.95,2.487,2.856,5.348,2.867,8.343c0,0.942-0.096,1.896-0.283,2.837l-1.781,8.899l9.073,0.338 c3.979,0.163,7.685,1.865,10.263,5.119c1.98,2.512,2.922,5.457,2.928,8.439c-0.012,4.087-1.781,8.065-5.228,10.788l0.012-0.006 c-3.381,2.663-7.021,3.9-9.961,3.888c-3.115-0.085-5.506-1.026-7.932-3.99l-4.829-6.127l-6.086,4.896 c-0.012,0.012-3.99,3.212-8.506,6.948c-2.258,1.865-4.648,3.864-6.761,5.675c-2.125,1.835-3.912,3.41-5.246,4.739 c-1.824,1.841-2.807,3.845-3.489,5.663c-1.153,3.205-1.558,6.182-2.071,9.212c-0.724,4.522-1.533,9.056-3.308,12.961 c-1.455,3.163-3.417,5.916-6.695,8.403c-14.114-18.159-33.94-34.808-56.88-46.484C315.446,169.293,323.095,168.4,330.798,168.037z M487.436,300.51c-2.644,1.092-5.294,1.618-7.667,1.618c-2.704-0.006-5.017-0.652-6.828-1.763c-1.811-1.135-3.248-2.686-4.335-5.24 l-2.735-6.605l-6.791,2.21c-0.024,0.012-20.61,6.707-25.796,8.385c-4.383,1.406-7.914,4.081-10.624,7.021 c-4.075,4.443-6.81,9.46-9.919,14.524c-3.085,5.077-6.43,10.239-11.041,15.117l-1.238,1.304c-1.726,1.189-3.653,2.403-5.777,3.586 c-7.311,4.104-16.354,7.95-23.496,10.709c-3.568,1.382-6.671,2.499-8.874,3.272c-1.099,0.386-1.974,0.682-2.566,0.882 c-0.598,0.199-0.893,0.295-0.893,0.295l3.815,11.76c0.103-0.037,9.762-3.164,20.978-7.915c5.487-2.324,11.343-5.047,16.704-8.029 c0.012,0.544,0.06,1.135,0.06,1.66c0,5.18-0.592,9.526-1.684,13.166c-1.962,6.339-5.138,10.667-10.673,14.549 c-8.27,5.784-22.662,9.744-43.58,11.79c-20.894,2.101-48.125,2.506-82.08,2.499c-19.125,0-40.39-0.12-63.903-0.12 c-43.224-0.006-76.505-5.294-104.7-14.64c-28.196-9.357-51.431-22.795-74.586-39.584c-1.729-1.273-2.511-2.396-3.033-3.513 c-0.507-1.105-0.718-2.313-0.722-3.592c-0.006-1.473,0.311-2.994,0.643-4.069l0.432-1.214l0.088-0.211l0.157-0.314l18.539-48.368 l0.058-0.199l0.051-0.138l1.057-1.787l0.374-0.326l0.139-0.012c0.199,0,0.888,0.042,2.276,0.755h0.006 c10.082,5.198,18.989,7.824,27.311,7.835c7.486,0.037,14.301-2.293,19.885-6.103c9.807-6.712,16.312-17,22.986-28.264 c9.912-16.976,19.972-36.68,36.423-52.37c16.468-15.636,39.037-27.8,76.142-29.526l1.929-0.09l-1.923,0.09 c3.348-0.157,6.768-0.23,10.227-0.23c19.556-0.018,40.266,2.59,57.332,9.2l3.616,1.394l0.386-0.242 c27.226,11.899,51.023,31.978,65.307,52.883l0.483-0.332c3.091,4.625,5.33,10.661,7.352,16.928 c-6.87-1.654-13.824-2.56-20.742-2.56c-10.571,0-21.044,1.902-30.958,5.627l-59.272,22.258l4.346,11.578l59.273-22.258 c8.53-3.212,17.524-4.842,26.61-4.842c7.304,0,14.658,1.141,21.89,3.296l-0.121,0.471c2.856,0.718,5.633,1.57,8.368,2.487 c0.555,0.236,1.122,0.405,1.678,0.652l0.018-0.048c6.526,2.282,12.744,4.914,18.69,7.389c8.958,3.652,17.314,7.124,26.436,7.214 c0.966,0,1.956-0.042,2.976-0.139l1.093-0.114l8.976-3.592l0.2-0.09c0.09-0.054,1.364-0.574,2.789-1.099 c2.191-0.815,5.071-1.841,7.377-2.65c2.306-0.808,4.038-1.4,4.045-1.4l7.788-2.68l-3.164-7.6c-0.785-1.878-1.141-3.785-1.147-5.675 c0.012-5.777,3.41-11.27,9.103-13.625l0.03-0.012c1.866-0.779,3.767-1.141,5.657-1.141c5.765,0.012,11.252,3.411,13.613,9.098 c0.761,1.823,1.105,3.664,1.111,5.506c0,2.348-0.586,4.702-1.672,6.846l-4.13,8.083l8.651,2.783 c4.081,1.328,7.443,4.171,9.176,8.301c0.767,1.853,1.129,3.761,1.129,5.644C496.54,292.644,493.135,298.144,487.436,300.51z"
          ></path>{" "}
        </g>{" "}
      </g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <style type="text/css"> </style>{" "}
        <g>
          {" "}
          <path
            className="st0"
            d="M438.574,178.819c-0.006,0-0.006,0.006-0.012,0.006l-0.597,0.471L438.574,178.819z"
          ></path>{" "}
          <path
            className="st0"
            d="M457.318,227.367l-0.284,0.121c0.006,0,0.012,0,0.019-0.006c0,0,0.006-0.006,0.012-0.006L457.318,227.367z"
          ></path>{" "}
          <path
            className="st0"
            d="M509.682,275.264c-2.451-5.88-6.64-10.414-11.585-13.577c0.471-2.113,0.749-4.28,0.749-6.49 c0-3.815-0.736-7.715-2.3-11.446c-4.829-11.591-16.046-18.618-27.878-18.611c-3.87,0-7.83,0.754-11.615,2.342 c-11.627,4.836-18.636,16.064-18.63,27.89c0,1.208,0.212,2.427,0.356,3.64c-0.018,0.006-0.03,0.012-0.048,0.018 c-1.745,0.622-3.568,1.274-5.156,1.872c-1.443,0.537-2.542,0.966-3.58,1.424l-6.514,2.608l-0.537,0.024 c-4.649,0.091-11.826-2.36-20.514-6.031c-5.723-2.373-12.194-5.132-19.288-7.618l0.428-0.139 c-2.064-6.339-4.207-14.12-7.987-21.654c2.868-2.53,5.228-5.3,6.991-8.174c4.365-7.136,5.668-14.458,6.598-19.945 c0.447-2.741,0.808-5.066,1.189-6.532c0.187-0.724,0.362-1.219,0.459-1.424c0.766-0.755,2.348-2.167,4.202-3.755 c2.994-2.572,6.737-5.668,9.707-8.101c0.048-0.036,0.085-0.066,0.127-0.103c4.316,2.952,9.285,4.582,14.204,4.528 c7.039-0.012,13.8-2.711,19.499-7.184l0.019-0.012c7.292-5.742,11.126-14.326,11.113-22.922c0.006-6.296-2.052-12.701-6.254-18.02 c-3.761-4.763-8.759-7.86-14.096-9.532c-0.368-5.59-2.264-11.216-6.025-15.985c-5.741-7.286-14.313-11.126-22.91-11.114 c-6.297-0.005-12.708,2.059-18.032,6.273l0.549-0.434l-0.537,0.422c-7.286,5.741-11.131,14.319-11.12,22.916 c-0.006,3.803,0.845,7.618,2.366,11.24l-4.014,3.17c-1.232,0.893-4.081,2.191-6.424,3.025c-1.195,0.434-2.288,0.79-3.054,1.026 l-0.893,0.266l-0.224,0.066l-0.042,0.012l-0.544,0.152l-0.5,0.217c-3.272,1.425-7.118,2.131-11.784,2.464 c-6.979,0.525-15.611,0.108-25.463,1.291c-8.91,1.075-18.853,3.647-29.164,9.496c-18.763-6.562-39.641-8.965-59.276-8.977 c-3.691,0-7.341,0.079-10.927,0.242h0.006c-30.67,1.34-53.728,9.72-71.252,21.714c-26.321,17.996-39.883,43.386-51.184,63.018 c-5.617,9.834-10.736,18.244-15.922,23.628c-2.587,2.705-5.125,4.66-7.724,5.934c-2.611,1.268-5.3,1.944-8.666,1.956 c-4.944,0.012-11.546-1.63-20.224-6.115l0.006,0.006c-3.082-1.6-6.254-2.488-9.375-2.488c-3.172-0.018-6.136,0.978-8.352,2.379 c-3.359,2.131-5.198,4.842-6.354,6.9c-0.912,1.654-1.382,2.958-1.597,3.622L2.542,322.001c-0.67,1.485-2.494,5.832-2.542,11.856 c-0.003,3.019,0.519,6.508,2.116,10.01c1.582,3.501,4.271,6.9,8.017,9.604c23.945,17.38,48.774,31.79,78.796,41.738 c30.021,9.961,65.101,15.436,109.566,15.43c23.459,0,44.712,0.12,63.903,0.12c25.968,0,48.147-0.223,66.957-1.298 c14.109-0.803,26.321-2.089,36.885-4.178c15.781-3.145,28.174-8.077,36.958-16.831c4.359-4.358,7.63-9.635,9.689-15.557 c2.071-5.928,2.982-12.454,2.982-19.595c0-3.097-0.223-6.357-0.549-9.714c6.23-7.256,10.298-14.476,13.631-19.861 c1.865-3.042,3.537-5.481,5.034-7.075c1.521-1.618,2.68-2.373,4.069-2.838c3.417-1.111,13.48-4.376,19.982-6.49 c1.944,2.506,4.238,4.636,6.828,6.212c4.54,2.783,9.731,4.045,14.905,4.039c4.594,0,9.206-0.972,13.601-2.795l0.018-0.006 c11.602-4.848,18.624-16.076,18.611-27.92C512,282.985,511.252,279.037,509.682,275.264z M330.798,168.037 c5.47-0.242,10.921-0.181,16.463-0.574c5.24-0.38,10.637-1.225,15.974-3.386c0.483-0.133,2.536-0.713,5.258-1.708 c3.03-1.129,6.682-2.584,10.076-4.938l0.151-0.103l15.72-12.394l-4.775-6.068c-1.998-2.541-2.934-5.481-2.94-8.451 c0.012-4.069,1.768-8.036,5.21-10.758l0.03-0.024c2.523-1.992,5.462-2.934,8.445-2.94c4.075,0.012,8.053,1.781,10.764,5.222 c1.95,2.487,2.856,5.348,2.867,8.343c0,0.942-0.096,1.896-0.283,2.837l-1.781,8.899l9.073,0.338 c3.979,0.163,7.685,1.865,10.263,5.119c1.98,2.512,2.922,5.457,2.928,8.439c-0.012,4.087-1.781,8.065-5.228,10.788l0.012-0.006 c-3.381,2.663-7.021,3.9-9.961,3.888c-3.115-0.085-5.506-1.026-7.932-3.99l-4.829-6.127l-6.086,4.896 c-0.012,0.012-3.99,3.212-8.506,6.948c-2.258,1.865-4.648,3.864-6.761,5.675c-2.125,1.835-3.912,3.41-5.246,4.739 c-1.824,1.841-2.807,3.845-3.489,5.663c-1.153,3.205-1.558,6.182-2.071,9.212c-0.724,4.522-1.533,9.056-3.308,12.961 c-1.455,3.163-3.417,5.916-6.695,8.403c-14.114-18.159-33.94-34.808-56.88-46.484C315.446,169.293,323.095,168.4,330.798,168.037z M487.436,300.51c-2.644,1.092-5.294,1.618-7.667,1.618c-2.704-0.006-5.017-0.652-6.828-1.763c-1.811-1.135-3.248-2.686-4.335-5.24 l-2.735-6.605l-6.791,2.21c-0.024,0.012-20.61,6.707-25.796,8.385c-4.383,1.406-7.914,4.081-10.624,7.021 c-4.075,4.443-6.81,9.46-9.919,14.524c-3.085,5.077-6.43,10.239-11.041,15.117l-1.238,1.304c-1.726,1.189-3.653,2.403-5.777,3.586 c-7.311,4.104-16.354,7.95-23.496,10.709c-3.568,1.382-6.671,2.499-8.874,3.272c-1.099,0.386-1.974,0.682-2.566,0.882 c-0.598,0.199-0.893,0.295-0.893,0.295l3.815,11.76c0.103-0.037,9.762-3.164,20.978-7.915c5.487-2.324,11.343-5.047,16.704-8.029 c0.012,0.544,0.06,1.135,0.06,1.66c0,5.18-0.592,9.526-1.684,13.166c-1.962,6.339-5.138,10.667-10.673,14.549 c-8.27,5.784-22.662,9.744-43.58,11.79c-20.894,2.101-48.125,2.506-82.08,2.499c-19.125,0-40.39-0.12-63.903-0.12 c-43.224-0.006-76.505-5.294-104.7-14.64c-28.196-9.357-51.431-22.795-74.586-39.584c-1.729-1.273-2.511-2.396-3.033-3.513 c-0.507-1.105-0.718-2.313-0.722-3.592c-0.006-1.473,0.311-2.994,0.643-4.069l0.432-1.214l0.088-0.211l0.157-0.314l18.539-48.368 l0.058-0.199l0.051-0.138l1.057-1.787l0.374-0.326l0.139-0.012c0.199,0,0.888,0.042,2.276,0.755h0.006 c10.082,5.198,18.989,7.824,27.311,7.835c7.486,0.037,14.301-2.293,19.885-6.103c9.807-6.712,16.312-17,22.986-28.264 c9.912-16.976,19.972-36.68,36.423-52.37c16.468-15.636,39.037-27.8,76.142-29.526l1.929-0.09l-1.923,0.09 c3.348-0.157,6.768-0.23,10.227-0.23c19.556-0.018,40.266,2.59,57.332,9.2l3.616,1.394l0.386-0.242 c27.226,11.899,51.023,31.978,65.307,52.883l0.483-0.332c3.091,4.625,5.33,10.661,7.352,16.928 c-6.87-1.654-13.824-2.56-20.742-2.56c-10.571,0-21.044,1.902-30.958,5.627l-59.272,22.258l4.346,11.578l59.273-22.258 c8.53-3.212,17.524-4.842,26.61-4.842c7.304,0,14.658,1.141,21.89,3.296l-0.121,0.471c2.856,0.718,5.633,1.57,8.368,2.487 c0.555,0.236,1.122,0.405,1.678,0.652l0.018-0.048c6.526,2.282,12.744,4.914,18.69,7.389c8.958,3.652,17.314,7.124,26.436,7.214 c0.966,0,1.956-0.042,2.976-0.139l1.093-0.114l8.976-3.592l0.2-0.09c0.09-0.054,1.364-0.574,2.789-1.099 c2.191-0.815,5.071-1.841,7.377-2.65c2.306-0.808,4.038-1.4,4.045-1.4l7.788-2.68l-3.164-7.6c-0.785-1.878-1.141-3.785-1.147-5.675 c0.012-5.777,3.41-11.27,9.103-13.625l0.03-0.012c1.866-0.779,3.767-1.141,5.657-1.141c5.765,0.012,11.252,3.411,13.613,9.098 c0.761,1.823,1.105,3.664,1.111,5.506c0,2.348-0.586,4.702-1.672,6.846l-4.13,8.083l8.651,2.783 c4.081,1.328,7.443,4.171,9.176,8.301c0.767,1.853,1.129,3.761,1.129,5.644C496.54,292.644,493.135,298.144,487.436,300.51z"
          ></path>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};
export const BirthdayCupcake = () => {
  return (
    <svg
      height="20px"
      width="20px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9999 3.125C13.9999 4.16053 13.1044 5 11.9999 5C10.8953 5 9.99988 4.16053 9.99988 3.125C9.99988 2.08947 11.9999 0 11.9999 0C11.9999 0 13.9999 2.08947 13.9999 3.125ZM0.460826 13.6423L2.31939 14.8317L4.02549 22.2249C4.1302 22.6786 4.53422 23 4.99988 23H18.9999C19.4655 23 19.8696 22.6786 19.9743 22.2249L21.6804 14.8317L23.5389 13.6423C24.0041 13.3446 24.1399 12.7261 23.8421 12.2609C23.5444 11.7958 22.926 11.66 22.4608 11.9577L21.9256 12.3003C21.5906 9.92302 19.5498 8 16.9717 8H12.9999V7C12.9999 6.44772 12.5522 6 11.9999 6C11.4476 6 10.9999 6.44772 10.9999 7V8H7.02808C4.44994 8 2.40918 9.92302 2.0742 12.3003L1.53893 11.9577C1.07376 11.66 0.455319 11.7958 0.157608 12.2609C-0.140103 12.7261 -0.0043478 13.3446 0.460826 13.6423ZM5.79539 21L4.65309 16.05C6.02133 16.4189 7.50983 16.1952 8.72873 15.3826L10.3358 14.3113C11.3435 13.6395 12.6563 13.6395 13.664 14.3113L15.271 15.3826C16.4899 16.1952 17.9784 16.4189 19.3467 16.05L18.2044 21H5.79539ZM16.9717 10C18.8713 10 20.2847 11.74 19.9135 13.588L19.6617 13.7492C18.6588 14.391 17.3712 14.379 16.3804 13.7185L14.7734 12.6472C13.0939 11.5275 10.9059 11.5275 9.22638 12.6472L7.61933 13.7185C6.62859 14.379 5.34099 14.391 4.33807 13.7492L4.08623 13.588C3.71509 11.74 5.12847 10 7.02808 10H11.9999H16.9717ZM8.99993 18C8.99993 17.4477 8.55221 17 7.99993 17C7.44764 17 6.99993 17.4477 6.99993 18V19C6.99993 19.5523 7.44764 20 7.99993 20C8.55221 20 8.99993 19.5523 8.99993 19V18ZM12.9999 18C12.9999 17.4477 12.5522 17 11.9999 17C11.4476 17 10.9999 17.4477 10.9999 18V19C10.9999 19.5523 11.4476 20 11.9999 20C12.5522 20 12.9999 19.5523 12.9999 19V18ZM16.9999 18C16.9999 17.4477 16.5522 17 15.9999 17C15.4476 17 14.9999 17.4477 14.9999 18V19C14.9999 19.5523 15.4476 20 15.9999 20C16.5522 20 16.9999 19.5523 16.9999 19V18Z"
          fill="#000000"
        ></path>{" "}
      </g>
    </svg>
  );
};
export const GraduationCap = () => {
  return (
    <svg
      height="20px"
      width="20px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M2 10L12 4.5L22 10L17.9457 12.2298M2 10L6.05427 12.2298M2 10V16M6 17.5V12.5C6 12.4084 6.01848 12.3182 6.05427 12.2298M6 17.5C6 18.6046 8.68629 19.5 12 19.5C15.3137 19.5 18 18.6046 18 17.5M6 17.5C6 16.3954 8.68629 15.5 12 15.5C15.3137 15.5 18 16.3954 18 17.5M18 17.5V12.5C18 12.4084 17.9815 12.3182 17.9457 12.2298M17.9457 12.2298C17.9334 12.1993 17.9189 12.1691 17.9025 12.139C17.3927 11.2067 14.9439 10.5 12 10.5C9.05606 10.5 6.60733 11.2067 6.09749 12.139C6.08105 12.1691 6.06663 12.1993 6.05427 12.2298"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{" "}
      </g>
    </svg>
  );
};
export const Books = () => {
  return (
    <svg
      height="20px"
      width="20px"
      fill="#000000"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <title>books</title>{" "}
        <path d="M30.639 26.361l-6.211-23.183c-0.384-1.398-1.644-2.408-3.139-2.408-0.299 0-0.589 0.040-0.864 0.116l0.023-0.005-2.896 0.776c-0.23 0.065-0.429 0.145-0.618 0.243l0.018-0.008c-0.594-0.698-1.472-1.14-2.453-1.143h-2.999c-0.76 0.003-1.457 0.27-2.006 0.713l0.006-0.005c-0.543-0.438-1.24-0.705-1.999-0.708h-3.001c-1.794 0.002-3.248 1.456-3.25 3.25v24c0.002 1.794 1.456 3.248 3.25 3.25h3c0.76-0.003 1.457-0.269 2.006-0.712l-0.006 0.005c0.543 0.438 1.24 0.704 1.999 0.708h2.999c1.794-0.002 3.248-1.456 3.25-3.25v-13.053l3.717 13.873c0.382 1.398 1.641 2.408 3.136 2.408 0.3 0 0.59-0.041 0.866-0.117l-0.023 0.005 2.898-0.775c1.398-0.386 2.407-1.646 2.407-3.141 0-0.298-0.040-0.587-0.115-0.862l0.005 0.023zM19.026 10.061l4.346-1.165 3.494 13.042-4.345 1.164zM18.199 4.072l2.895-0.775c0.056-0.015 0.121-0.023 0.188-0.023 0.346 0 0.639 0.231 0.731 0.547l0.001 0.005 0.712 2.656-4.346 1.165-0.632-2.357v-0.848c0.094-0.179 0.254-0.312 0.446-0.37l0.005-0.001zM11.5 3.25h2.998c0.412 0.006 0.744 0.338 0.75 0.749v2.75l-4.498 0.001v-2.75c0.006-0.412 0.338-0.744 0.749-0.75h0.001zM8.25 22.75h-4.5v-13.5l4.5-0.001zM10.75 9.25l4.498-0.001v13.501h-4.498zM4.5 3.25h3c0.412 0.006 0.744 0.338 0.75 0.749v2.75l-4.5 0.001v-2.75c0.006-0.412 0.338-0.744 0.749-0.75h0.001zM7.5 28.75h-3c-0.412-0.006-0.744-0.338-0.75-0.749v-2.751h4.5v2.75c-0.006 0.412-0.338 0.744-0.749 0.75h-0.001zM14.498 28.75h-2.998c-0.412-0.006-0.744-0.338-0.75-0.749v-2.751h4.498v2.75c-0.006 0.412-0.338 0.744-0.749 0.75h-0.001zM27.693 27.928l-2.896 0.775c-0.057 0.015-0.122 0.024-0.189 0.024-0.139 0-0.269-0.037-0.381-0.102l0.004 0.002c-0.171-0.099-0.298-0.259-0.35-0.45l-0.001-0.005-0.711-2.655 4.345-1.164 0.712 2.657c0.015 0.056 0.023 0.12 0.023 0.186 0 0.347-0.232 0.639-0.549 0.73l-0.005 0.001z"></path>{" "}
      </g>
    </svg>
  );
};
export const ChanpagneGlasses = () => {
  return (
    <svg
      fill="#000000"
      height="20px"
      width="20px"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 470 470"
      enableBackground="new 0 0 470 470"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <path d="M215,0H91.595c-4.142,0-7.5,3.358-7.5,7.5v242.065c0,35.624,27.06,65.038,61.702,68.789v110.994 c-22.62,1.815-44.017,11.772-59.603,27.948c-2.087,2.167-2.678,5.37-1.501,8.138c1.177,2.769,3.894,4.566,6.902,4.566H215 c3.008,0,5.725-1.797,6.902-4.566c1.177-2.768,0.586-5.972-1.501-8.138c-15.586-16.176-36.983-26.133-59.604-27.948V318.354 c34.643-3.752,61.703-33.165,61.703-68.789V7.5C222.5,3.358,219.142,0,215,0z M113.108,455 c11.994-7.082,25.919-10.957,40.189-10.957s28.196,3.875,40.189,10.957H113.108z M207.5,249.565 c0,29.888-24.315,54.203-54.203,54.203s-54.202-24.315-54.202-54.203V15H207.5V249.565z"></path>{" "}
          <path d="m185,232.065c-4.142,0-7.5,3.358-7.5,7.5v10c0,13.345-10.857,24.203-24.203,24.203-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5 7.5,7.5c21.616,0 39.203-17.586 39.203-39.203v-10c0-4.142-3.358-7.5-7.5-7.5z"></path>{" "}
          <path d="m121.595,83.104h55.905v126.46c0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-133.96c0-4.142-3.358-7.5-7.5-7.5h-63.405c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5 7.5,7.5z"></path>{" "}
          <circle cx="129.095" cy="113.104" r="7.5"></circle>{" "}
          <circle cx="129.095" cy="143.104" r="7.5"></circle>{" "}
          <path d="m385.905,249.565v-242.065c0-4.142-3.358-7.5-7.5-7.5h-123.405c-4.142,0-7.5,3.358-7.5,7.5v242.065c0,35.624 27.06,65.038 61.703,68.789v110.994c-22.62,1.815-44.017,11.772-59.604,27.948-2.087,2.167-2.678,5.37-1.501,8.138 1.177,2.769 3.894,4.566 6.902,4.566h123.405c3.008,0 5.725-1.797 6.902-4.566 1.177-2.768 0.586-5.972-1.501-8.138-15.586-16.176-36.983-26.133-59.603-27.948v-110.994c34.642-3.751 61.702-33.165 61.702-68.789zm-123.405,0v-234.565h108.405v234.565c0,29.888-24.315,54.203-54.202,54.203s-54.203-24.315-54.203-54.203zm14.013,205.435c11.994-7.082 25.919-10.957 40.189-10.957s28.195,3.875 40.189,10.957h-80.378z"></path>{" "}
          <path d="m355.905,249.565v-10c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v10c0,13.345-10.857,24.203-24.203,24.203-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5 7.5,7.5c21.617,0 39.203-17.587 39.203-39.203z"></path>{" "}
          <path d="m340.905,83.104v126.46c0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-133.96c0-4.142-3.358-7.5-7.5-7.5h-63.405c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5 7.5,7.5h55.905z"></path>{" "}
          <circle cx="292.5" cy="193.104" r="7.5"></circle>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};
export const WeddingCake = () => {
  return (
    <svg
      height="20px"
      width="20px"
      viewBox="0 0 24 24"
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          className="cls-1"
          d="M13.06.5A1.28,1.28,0,0,0,12,1.07a1.28,1.28,0,0,0-2.34.71C9.66,3.69,12,4.33,12,4.33s2.34-.64,2.34-2.55A1.28,1.28,0,0,0,13.06.5Z"
        ></path>
        <line className="cls-2" x1="23.48" y1="22.5" x2="0.52" y2="22.5"></line>
        <rect
          className="cls-2"
          x="3.39"
          y="15.8"
          width="17.22"
          height="6.7"
        ></rect>
        <rect
          className="cls-2"
          x="6.26"
          y="10.07"
          width="11.48"
          height="5.74"
        ></rect>
        <rect
          className="cls-2"
          x="9.13"
          y="6.24"
          width="5.74"
          height="3.83"
        ></rect>
        <path
          className="cls-2"
          d="M3.39,15.8l.86,1.51a3.83,3.83,0,0,0,6.44.33L12,15.8"
        ></path>
        <path
          className="cls-2"
          d="M20.61,15.8l-.86,1.51a3.83,3.83,0,0,1-6.44.33L12,15.8"
        ></path>
        <line className="cls-2" x1="6.26" y1="8.15" x2="6.26" y2="10.07"></line>
        <line className="cls-2" x1="3.39" y1="13.89" x2="3.39" y2="15.8"></line>
        <line
          className="cls-2"
          x1="17.74"
          y1="8.15"
          x2="17.74"
          y2="10.07"
        ></line>
        <line
          className="cls-2"
          x1="20.61"
          y1="13.89"
          x2="20.61"
          y2="15.8"
        ></line>
        <line
          className="cls-2"
          x1="13.91"
          y1="13.89"
          x2="13.91"
          y2="15.8"
        ></line>
        <line
          className="cls-2"
          x1="10.09"
          y1="13.89"
          x2="10.09"
          y2="15.8"
        ></line>
        <line className="cls-2" x1="12" y1="3.37" x2="12" y2="6.24"></line>
      </g>
    </svg>
  );
};
export const ValentinesChocolateHeart = () => {
  return (
    <svg
      fill="#000000"
      height="20px"
      width="20px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 503.936 503.936"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M369.476,16.952c-53.915,0-94.772,22.867-117.508,64.157c-21.424-38.908-58.943-61.448-108.311-63.921 c-0.176-0.009-0.354-0.013-0.53-0.021c-1.31-0.062-2.622-0.118-3.948-0.152c-1.564-0.041-3.136-0.063-4.718-0.063 c-1.393,0-2.773,0.024-4.147,0.059c-0.32,0.008-0.639,0.017-0.958,0.027c-2.819,0.089-5.597,0.251-8.335,0.483 c-0.194,0.017-0.388,0.033-0.582,0.05c-2.917,0.259-5.787,0.599-8.61,1.018c-0.012,0.002-0.024,0.003-0.036,0.005 C-3.048,35.641-39.553,182.147,50.448,282.134c14.158,15.73,52.535,55.694,106.701,111.389c0.692,0.712,1.393,1.431,2.087,2.145 c0.926,0.952,1.846,1.898,2.782,2.861c0.002,0.002,0.004,0.003,0.006,0.006c17.873,18.368,36.35,37.303,54.379,55.74 c13.146,13.443,25.842,26.401,29.58,30.202c3.289,3.345,8.681,3.345,11.97,0c3.738-3.801,16.434-16.759,29.58-30.202 c19.671-20.115,39.885-40.834,59.255-60.751c54.165-55.695,92.542-95.659,106.701-111.389 C549.171,175.835,501.875,16.952,369.476,16.952z M168.034,210.001c-4.636,0-8.393,3.758-8.393,8.393V372 c-19.188-19.754-35.971-37.101-50.361-52.067V218.394c0-4.636-3.758-8.393-8.393-8.393H26.361 c-5.879-16.591-9.029-33.614-9.407-50.361h83.932c4.636,0,8.393-3.758,8.393-8.393V36.101c6.237-1.208,12.747-1.974,19.529-2.246 c0.217-0.009,0.436-0.015,0.654-0.022c1.651-0.058,3.315-0.095,4.997-0.095c1.431,0,2.845,0.027,4.253,0.062 c0.524,0.014,1.048,0.028,1.57,0.047c0.775,0.027,1.543,0.065,2.311,0.103c5.841,0.295,11.524,0.902,17.046,1.83v115.467 c0,4.636,3.758,8.393,8.393,8.393h318.948c-0.378,16.747-3.528,33.77-9.407,50.361H168.034z M244.155,103.953 c2.788,7.102,12.838,7.102,15.626,0c17.764-45.257,55.693-70.214,109.695-70.214c68.724,0,111.467,49.077,117.103,109.115H176.427 V39.658C208.349,49.53,231.428,71.53,244.155,103.953z M92.493,40.659v102.194H17.357C21.736,96.205,48.526,56.193,92.493,40.659z M33.175,226.788h59.318v75.634c-13.672-14.324-23.75-25.055-29.568-31.518C50.358,256.943,40.508,242.048,33.175,226.788z M441.012,270.904c-13.946,15.494-52.297,55.431-106.258,110.916c-19.359,19.905-39.561,40.612-59.223,60.718 c-8.966,9.168-17.722,18.111-23.563,24.069c-5.84-5.958-14.597-14.901-23.563-24.069c-17.221-17.61-34.857-35.682-51.978-53.272 V226.788h294.335C463.428,242.048,453.578,256.943,441.012,270.904z"></path>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};
export const EarthDay = () => {
  return (
    <svg
      fill="#000000"
      height="20px"
      width="20px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.003 512.003"
      xmlSpace="preserve"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M298.73,128.309h-8.548c-4.427,0-8.014,3.588-8.014,8.014c0,4.426,3.587,8.014,8.014,8.014h8.548 c4.427,0,8.014-3.588,8.014-8.014C306.744,131.898,303.157,128.309,298.73,128.309z"></path>{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M350.02,171.051h-17.097c-4.427,0-8.014,3.588-8.014,8.014c0,4.426,3.587,8.014,8.014,8.014h17.097 c4.427,0,8.014-3.588,8.014-8.014C358.034,174.639,354.447,171.051,350.02,171.051z"></path>{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M307.278,222.342h-8.548c-4.427,0-8.014,3.588-8.014,8.014s3.587,8.014,8.014,8.014h8.548 c4.427,0,8.014-3.588,8.014-8.014S311.705,222.342,307.278,222.342z"></path>{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M439.233,383.748c-3.253-3.002-8.325-2.799-11.324,0.454l-58.131,62.977c-1.367,1.48-2.125,3.421-2.125,5.436v51.29 c0,4.426,3.587,8.014,8.014,8.014s8.014-3.588,8.014-8.014v-48.158l56.006-60.674 C442.689,391.821,442.486,386.749,439.233,383.748z"></path>{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M510.191,221.256c-1.34-3.415-3.409-6.536-6.065-9.071c-5.014-4.784-11.587-7.235-18.535-6.911 c-13.091,0.615-23.412,11.337-23.89,24.602l-3.462,15.479c-4.668-9.929-15.547-15.788-26.406-14.194 C416.148,148.372,343.27,85.567,255.988,85.567c-39.092,0-76.229,12.377-107.4,35.792c-3.539,2.659-4.252,7.682-1.594,11.221 c2.657,3.538,7.682,4.252,11.221,1.594c6.825-5.127,13.968-9.667,21.371-13.614v15.762c0,3.82,2.696,7.109,6.442,7.858 l38.181,7.636l7.078,21.233c0.798,2.394,2.676,4.271,5.069,5.069l20.166,6.722v25.99l-15.75,23.627 c-0.877,1.316-1.346,2.864-1.346,4.445v25.645c0,3.82,2.696,7.109,6.442,7.858l36.3,7.26v19.076c0,2.125,0.844,4.164,2.347,5.667 l39.401,39.401c-8.383,12.303-16.406,23.959-22.256,32.197c-7.159,10.083-10.943,21.968-10.943,34.37v13.401 c-22.694,4.919-46.745,4.921-69.456,0.003v-13.405c0-5.934-0.876-11.747-2.563-17.303l16.091-10.727 c1.658-1.106,2.847-2.79,3.33-4.724l8.548-34.193c0.159-0.636,0.239-1.289,0.239-1.944v-42.742c0-3.449-2.208-6.512-5.48-7.603 l-23.85-7.95l-23.746-23.745l-16.657-24.985c-1.486-2.229-3.988-3.569-6.668-3.569h-34.194c-3.036,0-5.811,1.715-7.168,4.43 l-8.445,16.888l-2.018-6.055v-24.345c0-3.449-2.208-6.512-5.479-7.603l-10.948-3.649c6.569-18.714,16.535-36.214,29.554-51.522 c2.868-3.371,2.459-8.43-0.913-11.297c-3.372-2.867-8.43-2.46-11.297,0.913c-20.18,23.725-33.687,52.242-39.439,82.539 c-1.215-0.18-2.442-0.297-3.685-0.297c-10.223,0-19.032,6.144-22.946,14.93c-1.32-6.144-2.494-11.828-3.373-16.473 c-2.706-14.286-11.813-23.511-23.768-24.074c-6.927-0.329-13.519,2.129-18.535,6.912c-2.654,2.532-4.73,5.655-6.062,9.073 c-1.258,3.23-2.309,7.442-1.512,10.9l25.645,111.129c0.313,1.358,0.976,2.609,1.92,3.633L128.298,455.75v48.156 c0,4.426,3.588,8.014,8.014,8.014s8.014-3.588,8.014-8.014v-51.29c0-2.014-0.759-3.956-2.125-5.436L41.062,337.611l-24.93-108.029 c0.401-4.817,4.686-8.526,9.5-8.298c6.255,0.295,8.297,8.529,8.773,11.046c4.613,24.36,16.667,74.699,17.178,76.83 c0.403,1.679,1.337,3.183,2.663,4.288l51.29,42.742c1.44,1.2,3.256,1.857,5.13,1.857h25.645c5.927,0,9.864-6.523,7.079-11.77 c-0.139-0.262-13.956-26.304-20.701-39.241c-5.526-10.6-2.457-13.625-1.3-14.763c3.413-3.363,8.838-3.469,12.377-0.346 c4.896,7.33,44.955,67.263,63.482,93.36c5.223,7.357,7.984,16.032,7.984,25.091v93.527c0,4.426,3.588,8.014,8.014,8.014 s8.014-3.588,8.014-8.014v-63.761c11.39,2.239,23.036,3.388,34.728,3.388c11.691,0,23.341-1.144,34.728-3.382v63.755 c0,4.426,3.587,8.014,8.014,8.014s8.014-3.588,8.014-8.014v-93.527c0-9.058,2.761-17.734,7.984-25.091 c18.528-26.097,58.586-86.029,63.482-93.36c3.541-3.123,8.964-3.018,12.377,0.345c1.075,1.059,4.346,4.282-1.249,14.668 c-4.8,8.909-20.611,39.069-20.77,39.372c-2.749,5.244,1.187,11.735,7.098,11.735h25.645c1.875,0,3.69-0.657,5.131-1.857 l51.29-42.742c1.384-1.149,2.352-2.791,2.722-4.547l17.066-76.314c0.128-0.574,0.193-1.16,0.193-1.749 c0-5.045,3.872-9.331,8.633-9.555c4.814-0.231,9.1,3.484,9.5,8.298l-24.929,108.029l-15.313,16.589 c-3.003,3.252-2.8,8.323,0.453,11.324c3.253,3.002,8.321,2.799,11.324-0.453l16.756-18.151c0.946-1.024,1.607-2.276,1.92-3.633 l25.645-111.129C512.536,228.556,511.506,224.616,510.191,221.256z M122.997,342.019h-9.429l-46.177-38.482v-47.536 c0-5.008,4.074-9.083,9.083-9.083c0.475,0,0.943,0.045,1.405,0.116c-0.571,5.801-0.871,11.644-0.871,17.515 c0,15.133,1.893,30.17,5.628,44.695c1.119,4.353,5.75,6.953,10.054,5.684c4.075-1.202,6.526-5.569,5.47-9.675 c-3.399-13.221-5.123-26.916-5.123-40.703c0-13.098,1.587-26.061,4.651-38.621l4.966,1.655v19.869 c0,0.861,0.139,1.717,0.411,2.535l8.548,25.645c0.34,1.02,0.887,1.926,1.565,2.707c-1.057,0.757-2.081,1.575-3.036,2.515 c-5.781,5.694-10.761,16.144-1.664,33.592C112.307,321.793,118.401,333.333,122.997,342.019z M211.89,378.348 c-0.506-0.79-64.842-95.393-65.281-96.052c-0.282-0.422-0.602-0.815-0.957-1.177c-4.872-4.945-11.304-7.439-17.752-7.474 l13.364-26.729h24.952l14.717,22.076c0.293,0.439,0.628,0.848,1.001,1.221l25.645,25.645c0.879,0.879,1.952,1.543,3.133,1.936 l20.166,6.722v35.979l-7.558,30.231L211.89,378.348z M350.554,264.549v37.399c0,0.71,0.102,1.393,0.275,2.048 c-5.223,7.773-11.397,16.94-17.745,26.313l-34.887-34.886v-22.326c0-3.82-2.696-7.109-6.442-7.858l-36.3-7.26v-16.649 l15.75-23.627c0.877-1.316,1.346-2.864,1.346-4.445v-34.194c0-3.449-2.207-6.512-5.48-7.603l-21.844-7.281l-7.281-21.843 c-0.909-2.728-3.211-4.76-6.032-5.325l-36.3-7.26v-16.226c0-0.139-0.014-0.274-0.02-0.41 c19.011-7.595,39.391-11.522,60.393-11.522c76.545,0,140.922,53.057,158.315,124.322c-0.39,0.513-0.731,1.074-0.996,1.693 l-8.732,20.376h-20.361c-0.861,0-1.717,0.139-2.535,0.411l-25.645,8.548C352.76,258.037,350.554,261.1,350.554,264.549z M444.588,303.538l-46.179,38.481h-9.484c5.014-9.54,11.705-22.242,14.525-27.477c9.83-18.245,3.209-28.938-1.612-33.688 c-9.78-9.635-25.517-9.585-35.254,0.03v-10.558l18.932-6.311h24.345c3.206,0,6.104-1.911,7.367-4.858l1.475-3.442 c0.157,2.926,0.242,5.87,0.242,8.834c0,12.629-1.448,25.206-4.306,37.381c-1.011,4.309,1.663,8.622,5.971,9.634 c4.253,0.998,8.636-1.72,9.634-5.971c3.139-13.374,4.73-27.183,4.73-41.044c0-5.911-0.296-11.753-0.858-17.519 c0.458-0.069,0.922-0.112,1.392-0.112c5.008,0,9.083,4.074,9.083,9.083V303.538z"></path>{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M470.933,78.852c-4.329-1.793-14.797-4.478-26.879,4.209c-12.082-8.687-22.551-6.002-26.879-4.209 c-9.311,3.857-15.328,12.995-15.328,23.278c-0.001,30.251,37.045,49.121,38.623,49.91c2.236,1.118,4.932,1.118,7.169,0 c1.577-0.789,38.624-19.659,38.624-49.91C486.261,91.845,480.244,82.709,470.933,78.852z M444.101,135.682 c-7.888-4.8-26.229-17.673-26.229-33.552c0.001-3.72,2.185-7.124,5.435-8.47c1.007-0.418,2.082-0.622,3.208-0.622 c3.642,0,7.809,2.148,11.87,6.21c3.131,3.13,8.204,3.13,11.334,0c5.317-5.318,10.812-7.355,15.078-5.589 c3.249,1.346,5.434,4.75,5.434,8.47C470.231,116.906,453.752,129.884,444.101,135.682z"></path>{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M94.803,78.852c-4.329-1.793-14.796-4.478-26.879,4.209c-12.083-8.687-22.551-6.002-26.879-4.209 c-9.311,3.857-15.328,12.995-15.328,23.278c0,30.251,37.047,49.121,38.624,49.91c2.237,1.118,4.931,1.118,7.168,0 c1.577-0.789,38.624-19.659,38.624-49.91C110.131,91.845,104.114,82.709,94.803,78.852z M67.972,135.682 c-7.888-4.8-26.229-17.673-26.229-33.552c0.001-3.72,2.185-7.124,5.436-8.47c1.007-0.418,2.081-0.622,3.207-0.622 c3.642,0,7.809,2.148,11.872,6.21c3.13,3.13,8.204,3.13,11.333,0c5.319-5.318,10.817-7.353,15.078-5.589 c3.25,1.346,5.434,4.75,5.434,8.47C94.102,116.906,77.624,129.884,67.972,135.682z"></path>{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M282.867,1.93c-4.328-1.793-14.797-4.477-26.879,4.209c-12.082-8.687-22.552-6.002-26.879-4.209 c-9.311,3.857-15.328,12.995-15.328,23.278c0,30.25,37.047,49.121,38.624,49.91c2.237,1.118,4.932,1.118,7.168,0 c1.577-0.789,38.624-19.659,38.624-49.91C298.196,14.924,292.179,5.788,282.867,1.93z M256.037,58.761 c-7.888-4.8-26.229-17.673-26.229-33.552c0-3.721,2.184-7.124,5.435-8.47c1.007-0.418,2.082-0.622,3.207-0.622 c3.642,0,7.809,2.148,11.872,6.21c3.129,3.129,8.202,3.13,11.334,0c5.317-5.318,10.812-7.355,15.078-5.589 c3.249,1.346,5.434,4.75,5.434,8.47C282.168,39.984,265.688,52.963,256.037,58.761z"></path>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};
export const TeaLeaves = () => {
  return (
    <svg
      height="20px"
      width="20px"
      fill="#000000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M20.553,3.105l-6,3C11.225,7.77,9.274,9.953,8.755,12.6c-.738,3.751,1.992,7.958,2.861,8.321A.985.985,0,0,0,12,21h0c6.682,0,11-3.532,11-9,0-6.691-.9-8.318-1.293-8.707A1,1,0,0,0,20.553,3.105Zm-7.6,15.86a8.594,8.594,0,0,1,5.44-8.046,1,1,0,1,0-.788-1.838,10.363,10.363,0,0,0-6.393,7.667,6.59,6.59,0,0,1-.494-3.777c.4-2,1.989-3.706,4.728-5.076l5.03-2.515A29.2,29.2,0,0,1,21,12C21,16.063,17.94,18.67,12.954,18.965ZM3.523,5.38A29.2,29.2,0,0,0,3,12a6.386,6.386,0,0,0,4.366,6.212,1,1,0,1,1-.732,1.861A8.377,8.377,0,0,1,1,12c0-6.691.9-8.318,1.293-8.707a1,1,0,0,1,1.154-.188l6,3A1,1,0,0,1,8.553,7.9Z"></path>
      </g>
    </svg>
  );
};

// Jester hat for April Fools' Day
export const JesterHat = () => {
  return (
    <svg
      height="20px"
      width="20px"
      fill="#000000"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M256 32c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V96c0-35.3-28.7-64-64-64zm-128 96c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64 17.7 0 33.7-7.2 45.3-18.7C162.7 280.7 176 297.6 176 320v112c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V320c0-22.4 13.3-39.3 32.7-50.7 11.6 11.5 27.6 18.7 45.3 18.7 35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64s-64 28.7-64 64v32c0 5.5.7 10.9 2 16-11.3 7.3-21.3 16.4-29.5 27-8.2-10.6-18.2-19.7-29.5-27 1.3-5.1 2-10.5 2-16v-32c0-35.3-28.7-64-64-64z"></path>
      </g>
    </svg>
  );
};

// Rose for Mother's Day
export const Rose = () => {
  return (
    <svg
      height="20px"
      width="20px"
      fill="#000000"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M256 16c-35.3 0-67.3 14-90.5 36.7C142.3 29 110.3 16 75 16 33.6 16 0 49.6 0 91c0 82.7 67.3 150 150 150h12.5c-4.8 17.5-7.5 36-7.5 55.3V480c0 17.7 14.3 32 32 32h138c17.7 0 32-14.3 32-32V296.3c0-19.3-2.7-37.8-7.5-55.3H362c82.7 0 150-67.3 150-150 0-41.4-33.6-75-75-75-35.3 0-67.3 13-90.5 36.7C323.3 30 291.3 16 256 16z"></path>
      </g>
    </svg>
  );
};

// Flag for Memorial Day
export const Flag = () => {
  return (
    <svg
      height="20px"
      width="20px"
      fill="#000000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M4 21V4h16v10H6v7H4zM6 12h12V6H6v6z"></path>
      </g>
    </svg>
  );
};

// Tie for Father's Day
export const Tie = () => {
  return (
    <svg
      height="20px"
      width="20px"
      fill="#000000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M12 2L9 5l1.5 3.5L7 22h10l-3.5-13.5L15 5l-3-3zm0 4.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z"></path>
      </g>
    </svg>
  );
};

// Fireworks for Independence Day
export const Fireworks = () => {
  return (
    <svg
      height="20px"
      width="20px"
      fill="#000000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2zM5 3v2h2V3H5zm12 0v2h2V3h-2zM3 9v2h2V9H3zm16 0v2h2V9h-2zM5 19v2h2v-2H5zm12 0v2h2v-2h-2z"></path>
      </g>
    </svg>
  );
};

// Hard hat for Labor Day
export const HardHat = () => {
  return (
    <svg
      height="20px"
      width="20px"
      fill="#000000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M12 2C8.43 2 5.23 4.11 4.1 7.27L2 8.5V10h2v5H2v2h20v-2h-2v-5h2V8.5l-2.1-1.23C18.77 4.11 15.57 2 12 2zm0 2c2.67 0 5.04 1.54 6.15 4H5.85C6.96 5.54 9.33 4 12 4zM6 10h12v5H6v-5z"></path>
      </g>
    </svg>
  );
};

// Shofar for Rosh Hashana
export const Shofar = () => {
  return (
    <svg
      height="20px"
      width="20px"
      fill="#000000"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M477.7 98.5c-16.2-12.1-38.8-8.8-50.9 7.3l-71.5 95.3c-23.6-19.3-53.7-30.9-86.3-30.9-75.1 0-136 60.9-136 136s60.9 136 136 136c32.6 0 62.7-11.6 86.3-30.9l71.5 95.3c12.1 16.1 34.7 19.4 50.9 7.3 16.1-12.1 19.4-34.7 7.3-50.9L418 370.3c12.8-24.5 20-52.2 20-81.8s-7.2-57.3-20-81.8l67.1-89.4c12.1-16.1 8.8-38.7-7.4-50.8zM269 442.5c-64.2 0-116.5-52.3-116.5-116.5S204.8 209.5 269 209.5s116.5 52.3 116.5 116.5S333.2 442.5 269 442.5z"></path>
      </g>
    </svg>
  );
};

// Peace dove for MLK Day
export const PeaceDove = () => {
  return (
    <svg
      height="20px"
      width="20px"
      fill="#000000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M12.5 2C9.46 2 7 4.46 7 7.5c0 1.33.47 2.55 1.26 3.5H7c-1.1 0-2 .9-2 2v2c0 .55.22 1.05.59 1.41L9 19.83V22h2v-2.17l1-1V22h2v-4c0-.28-.11-.53-.29-.71l-2-2A.996.996 0 0 0 11 15v-1.83l1.26 1.26c.79.79 1.79 1.32 2.91 1.52.48.09.97.13 1.47.13 1.5 0 2.95-.42 4.17-1.22l.19-.13V7.5C21 4.46 18.54 2 15.5 2h-3zm6.5 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"></path>
      </g>
    </svg>
  );
};

// Star badge for Presidents Day
export const PresidentStar = () => {
  return (
    <svg
      height="20px"
      width="20px"
      fill="#000000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
      </g>
    </svg>
  );
};
